module.exports = __webpack_public_path__ + "img/avatar.ddc782cd.jpg";